import * as angular from 'angular';
import * as _ from 'lodash';

import { ConnectionPointType } from '../../models/enum/ConnectionPointType';
import { ConnectionPoint } from '../../models/ConnectionPoint';
import { IDataFolderService, ITranslatedLoggerService, IStoreService } from '../../services';
import { ComponentDefinition, DataFolder, FileInformation, Dictionary } from '../../models';
import { Store, StoreElement } from '../../stateManagement';

class DataFolderStateController implements angular.IComponentController {
    connectionPoints: Dictionary<ConnectionPoint> = {};
    isLoading = false;
    items: DataFolder;
    selectedGuid: string;
    selectedItem: FileInformation;

    private _unsubscribe: Function;

    static $inject = ['$stateParams', 'dataFolderService', 'storeService', 'translatedLoggerService'];

    constructor(
        private _$stateParams: angular.ui.IStateParamsService,
        private _dataFolderService: IDataFolderService,
        private _storeService: IStoreService,
        private _loggerService: ITranslatedLoggerService
    ) {}

    $onInit() {
        this._unsubscribe = this._storeService.register((store) => this.refreshStore(store), [StoreElement.ConnectionPoints]);
    }

    $onDestroy() {
        this._unsubscribe();
    }

    private refreshStore(store: Store) {
        const connectionPoints = _.values(store.connectionPoints.dictionary);
        const filteredConnectionPoints = {};
        connectionPoints.forEach((cp) => {
            if (cp.type === ConnectionPointType.DataFolder) {
                filteredConnectionPoints[cp.guid] = cp;
            }
        });
        this.connectionPoints = filteredConnectionPoints;
        if (!this._$stateParams.files) {
            this.refresh();
        } else {
            this.items = this._$stateParams.files;
        }
        this.isLoading = false;
    }

    refresh() {
        this.isLoading = true;
        this._dataFolderService
            .list()
            .then((dto) => {
                this.items = dto;
            })
            .catch((reason) => this._loggerService.logError('Problem while loading files list'))
            .finally(() => (this.isLoading = false));
    }

    onFileSelected(guid: string, file: FileInformation) {
        this.selectedGuid = guid;
        this.selectedItem = file;
    }

}

export const dataFolderState: ComponentDefinition = {
    componentId: 'wtDataFolderState',
    controller: DataFolderStateController,
    controllerAs: 'vm',
    template: require('./dataFolderState.component.html'),
    bindings: {}
};
